import { render, staticRenderFns } from "./RgpTagSelector.vue?vue&type=template&id=26382c1a&scoped=true&"
import script from "./RgpTagSelector.vue?vue&type=script&lang=js&"
export * from "./RgpTagSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26382c1a",
  null
  
)

export default component.exports